import { Injectable } from '@angular/core';
import {
    ValidatorFn,
    Validators
} from '@angular/forms';
import {
    DatiqInputErrorTypes,
    IDatiqInput,
    IDatiqInputValidatorService,
} from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqInputValidatorRequiredService
    implements IDatiqInputValidatorService
{
    constructor() {}

    addValidator(
        settings: IDatiqInput,
        currentValidators: ValidatorFn[]
    ): ValidatorFn[] {
        return !!settings?.[DatiqInputErrorTypes.Required]
            ? [...currentValidators, Validators.required]
            : [...currentValidators];
    }
}
